import React, { ReactNode } from "react";

import "./faq.css";

import FAQElement from "../components/faqElement";

class FAQContent {
    title: string;
    content: ReactNode;
    constructor(title: string, content: ReactNode) {
        this.title = title;
        this.content = content;
    }
}

const faqQuestions = [
    new FAQContent("What's Txoria?", "Txoria is a platform designed to make it easy for you to upload & share or browse & find accordion music. The mission is, to create one big libary full with accordion scores through all instrumentaitons and genres."),
    new FAQContent("Who's behind Txoria?", <>
    Txoria was founded by a young website company from Germany called<a href="https://vueste.de" target="_blank">Vueste UG</a>
    </>),
    new FAQContent("How does it work?", <>
    You can search pieces for yourself, or your ensemble through our filter system under<a href="/pieces">pieces</a>. Every free piece can be downloaded directly.
    To buy a piece, you need to create an account.
    If you add money to your account balance, and buy the piece with that, you don't have to pay the fees of our third-party payment service stripe.
    <br/>
    <br/>
    Creating an account gives you many more features, such as liking or bookmarking pieces, or uploading your own pieces.
    </>),
    new FAQContent("How can i participate?", <>
    To upload your own pieces, or transcriptions you made, you first need to create an account. After that, fill out some basic information about yourself and your biographys. And with that in place, you can start publishing.
    You can fill out very detailed inforamtion about the piece, such as its difficulty, the instrumentation, genre, who played your piece, and much more. Remember: The more precice you are, the easier it is for players to find your piece.
    </>),
    new FAQContent("How are fees calculated?", <>
    There are two types of fees:<br/>
    <ul>
        <li>1. Fees to our third-party payment service stripe. 25ct + 1.5%. You don't have to pay these fees if you buy pieces directly with your account balance</li>
        <li>2. We keep 18.5% each purchase to pay all the costs our company has for keeping the website alive. (for example server costs)</li>
    </ul>
    This means a composer earns 80% of the pieces price - 25ct every time the piece is sold.
    </>)
]


export default function FAQPage() {
    return <div className="page keep-margin">
        <h1>Frequently Asked Questions</h1>
        <div className="faq-list">
            {faqQuestions.map((faq, index) => {
                return <FAQElement key={index} title={faq.title} content={faq.content}/>;
            })}
        </div>
    </div>
}